import script from "./FormButtonGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormButtonGroup.vue?vue&type=script&lang=ts&setup=true"

import "./FormButtonGroup.vue?vue&type=style&index=0&id=7cf3733e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cf3733e"]])

export default __exports__